import { createFileRoute } from "@tanstack/react-router";

import { ComparePage } from "@/features/compare/ComparePage";
import {
  type CompareSearch,
  parseCompareSearch,
} from "@/features/compare/compare-url";

export type { CompareSearch };

export const Route = createFileRoute("/_authenticated/compare")({
  validateSearch: (search: Record<string, unknown>): CompareSearch =>
    parseCompareSearch(search),
  component: ComparePage,
});
